module.exports = __webpack_public_path__ + "img/reference13.23aed311.jpg";